import { render, staticRenderFns } from "./DeliverablesWidgetGroup.vue?vue&type=template&id=71318452&scoped=true"
import script from "./DeliverablesWidgetGroup.vue?vue&type=script&lang=js"
export * from "./DeliverablesWidgetGroup.vue?vue&type=script&lang=js"
import style0 from "./DeliverablesWidgetGroup.vue?vue&type=style&index=0&id=71318452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71318452",
  null
  
)

export default component.exports